module.exports = __webpack_public_path__ + "img/szechenyi_2020_logo_fekvo_color_RGB.54600080.png";